import { render } from "./AddNewCustomerGroup.vue?vue&type=template&id=2f170d3a"
import script from "./AddNewCustomerGroup.vue?vue&type=script&lang=js"
export * from "./AddNewCustomerGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__